import { useState, useEffect, useContext } from 'react';
import { Container, Form, Button} from 'react-bootstrap';
import { useNavigate, Navigate } from 'react-router-dom';
import UserContext from '../UserContext';
import Swal from 'sweetalert2';




export default function Register(){

  // State hooks tto store the values of the input fields
    const [email, setEmail] = useState('');
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');

  // State to determine whether submit button is enabled or not
  const [isActive, setIsActive] = useState('');

  const {user} = useContext(UserContext);

    //an object with methods to redirect the user
    const navigate = useNavigate();


  console.log(email);
  console.log(password1);
  console.log(password2);

  // Function to simulate user registration
  function registerUser(e) {

            // Prevents page redirection via form submission
            e.preventDefault();

            fetch(`${ process.env.REACT_APP_API_URL}/users/checkEmail`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email
                })
            })
            .then(res => res.json())
            .then(data => {

                console.log(data);

                if(data === true){

                    Swal.fire({
                        title: 'Duplicate email found',
                        icon: 'error',
                        text: 'Please provide a different email.'   
                    });

                } else {

                    fetch(`${ process.env.REACT_APP_API_URL}/users/register`, {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            email: email,
                            password: password1
                        })
                    })
                    .then(res => res.json())
                    .then(data => {

                        console.log(data);

                        if(data === true){

                            // Clear input fields
                            setEmail('');
                            setPassword1('');
                            setPassword2('');

                            Swal.fire({
                                title: 'Registration successful',
                                icon: 'success',
                                text: "Bud's Place Games!"
                            });

                            // Allows us to redirect the user to the login page after registering for an account
                            navigate("/login");

                        } else {

                            Swal.fire({
                                title: 'Something wrong',
                                icon: 'error',
                                text: 'Please try again.'   
                            });

                        };

                    })
                };

            })

        }



useEffect(() => {

    // Validation to enable submit button when all fields are populated and both passwords match
    if((email !== '' && password1 !== '' && password2 !== '') && (password1 === password2)){
        setIsActive(true);
    } else {
        setIsActive(false);
    }

}, [email, password1, password2]);


return (
  <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
    <Form onSubmit={(e) => registerUser(e)} style={{ maxWidth: '600px', width: '100%', border: '1px solid #ccc', padding: '20px' }}>
      <h1 className="text-center mb-4">Register</h1>
      <Form.Group controlId="userEmail" style={{ marginBottom: '1rem' }}>
        <Form.Label>Email address</Form.Label>
        <Form.Control
          type="email"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group controlId="password1" style={{ marginBottom: '1rem' }}>
        <Form.Label>Password</Form.Label>
        <Form.Control
          type="password"
          placeholder="Password"
          value={password1}
          onChange={(e) => setPassword1(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group controlId="password2" style={{ marginBottom: '1rem' }}>
        <Form.Label>Verify Password</Form.Label>
        <Form.Control
          type="password"
          placeholder="Verify Password"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
          required
        />
      </Form.Group>

      {isActive ? (
        <Button variant="primary" type="submit" id="submitBtn" className="mt-3">
          Submit
        </Button>
      ) : (
        <Button variant="primary" type="submit" id="submitBtn" className="mt-3" disabled>
          Submit
        </Button>
      )}
    </Form>
  </Container>
);
}